<template>
  <div class="detail">
    <login :fh='1'></login>
    <div class="detail_body">
            <div class="detail_body_banner">
                <img v-if='data_detail.subject == 13' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_01.jpg">
                <img v-if='data_detail.subject == 9' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_02.jpg">
                <img v-if='data_detail.subject == 33' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_03.jpg">
                <img v-if='data_detail.subject == 19' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_04.jpg">
                <img v-if='data_detail.subject == 12' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_05.jpg">
                <img v-if='data_detail.subject == 16' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_06.jpg">
                <img v-if='data_detail.subject == 10' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_07.jpg">
                <img v-if='data_detail.subject == 6' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_08.jpg">
                <img v-if='data_detail.subject == 22' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_09.jpg">
                <img v-if='data_detail.subject == 8' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_10.jpg">
                <img v-if='data_detail.subject == 25' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_11.jpg">
                <img v-if='data_detail.subject == 17' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_12.jpg">
                <img v-if='data_detail.subject == 14' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_13.jpg">
                <img v-if='data_detail.subject == 7' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_14.jpg">
                <img v-if='data_detail.subject == 23' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_15.jpg">
                <img v-if='data_detail.subject == 5' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_16.jpg">
                <img v-if='data_detail.subject == 24' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_17.jpg">
            </div>
            <div class="detail_body_title">
                <div class="detail_body_title_flex">
                    <span class="detail_body_title_flex_left" v-if="Number(data_detail.sale_price) != 0">￥<span>{{ data_detail.sale_price }}</span></span>
                    <span class="detail_body_title_flex_left" v-else><span>免费</span></span>
                    <span class="detail_body_title_flex_right">{{ data_detail.member_num_fictitious }}人已购买</span>
                </div>
                <h3>{{ data_detail.doc_name}}</h3>
            </div>
            <span class="detail_body_span"></span>
            <div class='deatil_title'>※ 本资料为电子版，仅支持在线查看，不可复制，不可下载。一旦购买成功，恕不接受退款，请慎重购买哦~</div>
            <span class="detail_body_span"></span>
            <div class="detail_body_list">
                <div class="detail_body_list-spa"></div>
                <div class="spaniv">
                    <div :class="activeName == 1 ? 'spaniv_active' : ''" @click="handleClick(1)">
                        详情
                    </div>
                    <div :class="activeName == 2 ? 'spaniv_active' : ''" @click="handleClick(2)">
                        相关推荐
                    </div>
                </div>

                <div v-if="activeName == 1">
                    <div class="body_p" v-if="data_detail.buy == 0">
                        <div v-html="data_detail.see_content" style="width:100%;"></div>
                        <p class="body_p_sp">购买后即可阅读全文哦</p>
                        <img class="body_p_img" src="@/assets/img/detail_01.png">
                    </div>

                    <div class="body_p" v-if="data_detail.buy == 1">
                        <div v-html="data_detail.content" style="width:100%;"></div>
                    </div>
                </div>
                <div v-if="activeName == 2">
                    <div class="detail_body_list_class">
                        <div class="detail_body_list_classtitle" v-if="data_class.length != 0 ">
                            <img src="@/assets/img/detail_03.png" />
                            <p><span> {{ district_and_name }}</span>相关课程</p>
                        </div>
                        <div class="detail_body_list_class_item" v-for="item in data_class" :key='item.id'>
                            <div class="detail_body_list_class_item_left">
                                <img :src="item.path" v-if='item.path != null'/>
                                <img v-else src="https://fview.5kjs.com/wap_img/newShool/product/newshoolcommon/common.png" />
                            </div>
                            <div class="detail_body_list_class_item_right">
                                <h3>{{ item.name }}</h3>
                                <!-- <p> {{ item.description }}</p> -->
                                <div>
                                    <span><span>￥</span>{{ item.sale_price }}</span>
                                    <a v-if="item.sale_price == 0 || item.sale_price == ''" :href="'/m/productdetail?type=class&id=' + item.id">立即学习</a>
                                    <a v-else :href="'/m/productdetail?type=class&id=' + item.id">立即购买</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detail_body_list_class">
                        <div class="detail_body_list_classtitle" v-if="data_library.length != 0 ">
                            <img src="@/assets/img/detail_02.png" />
                            <p><span>{{ district_and_name }}</span>考试资料</p>
                        </div>
                        <div class="detail_body_list_class_item" v-for="item in data_library" :key='item.id'>
                            <div class="detail_body_list_class_item_left" v-if="item.paper_id != null">
                                <img v-if='item.paper_subject == 13' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_01.jpg">
                                <img v-if='item.paper_subject == 9' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_02.jpg">
                                <img v-if='item.paper_subject == 33' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_03.jpg">
                                <img v-if='item.paper_subject == 19' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_04.jpg">
                                <img v-if='item.paper_subject == 12' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_05.jpg">
                                <img v-if='item.paper_subject == 16' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_06.jpg">
                                <img v-if='item.paper_subject == 10' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_07.jpg">
                                <img v-if='item.paper_subject == 6' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_08.jpg">
                                <img v-if='item.paper_subject == 22' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_09.jpg">
                                <img v-if='item.paper_subject == 8' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_10.jpg">
                                <img v-if='item.paper_subject == 25' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_11.jpg">
                                <img v-if='item.paper_subject == 17' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_12.jpg">
                                <img v-if='item.paper_subject == 14' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_13.jpg">
                                <img v-if='item.paper_subject == 7' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_14.jpg">
                                <img v-if='item.paper_subject == 23' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_15.jpg">
                                <img v-if='item.paper_subject == 5' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_16.jpg">
                                <img v-if='item.paper_subject == 24' src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/written/banner_17.jpg">
                                <img v-else src="https://fview.5kjs.com/wap_img/newShool/product/newshoolcommon/library.png" />
                            </div>
                            <div class="detail_body_list_class_item_left" v-else>
                                <img src="https://fview.5kjs.com/wap_img/newShool/product/newshoolcommon/library.png" />
                            </div>
                            <div class="detail_body_list_class_item_right">
                                <h3>{{ item.doc_name }}</h3>
                                <!-- <p> {{ item.description }}</p> -->
                                <div>
                                    <span><span>￥</span>{{ item.sale_price }}</span>
                                    <a v-if="item.sale_price == 0 || item.sale_price == ''" :href="'/m/productdetail?type=library&id=' + item.id">立即学习</a>
                                    <a v-else :href="'/m/productdetail?type=library&id='+ item.id ">立即购买</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a v-if="activeName == 2" href="/m/productcentre" class='Results_body_a'>点击查看更多 <i data-v-01a26dda="" class="van-icon van-icon-arrow"><!----></i></a>
            <span class="detail_body_span"></span>
    </div>



    <div class="detail_fle">
        <button v-if="api_token != '' && data_detail.buy == 0 && Number(data_detail.sale_price) != 0" @click="gm">立即购买</button>
        <button v-if="api_token != '' && data_detail.buy == 0 && Number(data_detail.sale_price) == 0" @click="gm">免费领取</button>
        <button @click="attestation" v-if="api_token == '' && data_detail.buy == 0">立即登录</button>
        <div class="detail_fle_flex" v-if="api_token != '' && data_detail.buy == 1">
            <van-field v-model="value" placeholder="写下你的留言..." />
            <button @click="detail_click">发送</button>
        </div>
    </div>
    <kfu />
    <proposal :id='zo_id' :is_like='data_detail.is_like' :like='data_detail.like' :api_token='api_token' :agency_id='agency_id' class="clas_parpoosal"/>

    <div class="box_body box_body_s" v-if="activeName == 1">
        <div class="box_list">
            <h4>精选留言</h4>
            <span></span>
        </div>
        <div class="box_ul">
            <div class="box_ul_item" v-for="item in revi_detail" :key='item.id'>
                <div class="box_ul_left">
                    <img :src="item.avatar" />
                </div>
                <div class="box_ul_right">
                    <div class="box_ul_right_title">
                        <div>
                            <p>{{item.realname}}</p>
                            <span v-if="item.is_top == 1">置顶</span>
                        </div>
                        <div class="">
                            <span>{{item.like}}</span>
                            <img src="@/assets/img/dzi_01.png" @click="is_click(item.id)" v-if="item.is_like == 0"/>
                            <img src="@/assets/img/dzi_02.png" v-else/>
                        </div>
                    </div>
                    <p>{{item.create_time}}</p>
                    <p class="box_ul_p">{{item.content}}</p>
                    <div class="box_ul_ps" v-if="item.reply != ''">
                        <span>新百易君</span>：
                        {{item.reply}}
                    </div>
               </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import login from '@/components/login/index.vue'
  import Bottom from '@/components/bottom/index.vue'
  import proposal from '@/components/proposal/index.vue'
  import kfu from '@/components/kfu/index.vue'
  import Cookie from 'js-cookie'
  export default {
    name: "detail",
    data() {
      return {
          data_detail:{},
          activeName: 1,
          data_class: [],
          data_library:[],
          district_and_name: '',
          show_logo: false,
          zo_id: 0,
          value: '',
          revi_detail: [],
          token: this.api_token,
      };
    },
    props:['api_token', 'agency_id'],
    created() {
        
    },
    methods:{
        //点赞
        is_click(id) {
            this.$axios.get('reviewLike', {params:{token: this.token,id: id, agency_id: this.agency_id}},).then((d)=> {
                if(d.code == 200) {
                    this.$toast(d.message)
                    this.reviewList(this.zo_id)
                }else if(d.code == 202) {
                    this.show_logo = true
                }else {
                    this.$toast(d.message)
                }
            }).catch((err) => {
                // // this.$toast(err)
            });
        },
        //发送消息
        detail_click() {
            this.$axios.get('textpaperReview', {params:{token: this.token,id: this.zo_id, content: this.value,agency_id: this.agency_id}},).then((d)=> {
                if(d.code == 200) {
                    this.value = ''
                    this.$toast(d.message)
                    this.reviewList(this.zo_id)
                }else if(d.code == 202) {
                    this.show_logo = true
                }else {
                    this.$toast(d.message)
                }
            }).catch((err) => {
                // this.$toast(err)
            });
        },
        //购买
        gm() {
            console.log()
            var formData = new FormData();
            formData.append('id', this.data_detail.extra_id)
            formData.append('type', 'library')
            formData.append('token', this.api_token)
            formData.append('agency_id', this.agency_id)
            formData.append('paper_id', this.data_detail.id)
            window.location.href = '/m/productdetail?type=library&id=' + this.data_detail.extra_id
            // this.$axios.post('createOrder',  formData,{
            //   headers: {
            //     'Content-Type': 'multipart/form-date'
            //   }
            // }).then((d)=> {
            //     if(d.code == 200) {
            //         window.location.href = d.data.url
            //         this.$toast(d.message)
            //         this.reviewList(this.zo_id)
            //     }else if(d.code == 202) {
            //         this.show_logo = true
            //     }else {
            //         this.$toast(d.message)
            //     }
            // }).catch((err) => {
            //     // this.$toast(err)
            // });
        },
        //立即登录
        attestation () {
            var localhost = window.location.href;
            var host = window.location.href.replace(/#/g,"vue")
            window.location.href = window.location.origin + '/m/login?turn_jump_url=' + host;
        },
        //点击tab
        handleClick(tab) {
            this.activeName = tab
        },
        //获取留言
        reviewList(id){
            this.$axios.get('reviewList', {params:{token: this.token,id: id, agency_id: this.agency_id}},).then((d)=> {
                if(d.code == 200) {
                    this.show_logo = false
                    this.revi_detail = d.data.data
                }else if(d.code == 202) {
                    this.show_logo = true
                }else {
                    this.$toast(d.message)
                }
            }).catch((err) => {
                // this.$toast(err)
            });
        },
        //获取详情页
        getTextpaperInfo(id){
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                background: 'rgba(0, 0, 0, 1)'
            });
            this.$axios.get('getTextpaperInfo', {params:{token: this.token,id: id }},).then((d)=> {
                loading.close();
                if(d.code == 200) {
                    this.show_logo = false
                    this.data_detail = d.data
                    this.data_class = d.data.class
                    this.data_library = d.data.library
                }else if(d.code == 202) {
                    this.show_logo = true
                }else {
                    this.$toast(d.message)
                }
            }).catch((err) => {
                // this.$toast(err)
            });
        },
        //获取课程
        recommendList(area_id, district_and_name, district_and_county){
            //  var formData = new FormData();
            // formData.append('district', area_id)
            // formData.append('province', 430000)
            // formData.append('county_id', district_and_county)
            // formData.append('district_and_county', district_and_name)
            // this.$axios.post('recommendList', formData,{
            //   headers: {
            //     'Content-Type': 'multipart/form-date'
            //   }
            // }).then((d)=> {
            //     if(d.code == 200) {
            //         this.show_logo = false
            //         this.data_class = d.data
            //     }else if(d.code == 202) {
            //         this.show_logo = true
            //     }else {
            //         this.$toast(d.message)
            //     }
            // }).catch((err) => {
            //     // this.$toast(err)
            // });
        }
    },
    mounted() {
        if(this.api_token != '') {
            this.token = this.api_token
        }else {
            this.token = localStorage.getItem('api_token')
            console.log( this.token)
        }
        let id = this.$route.query.id
        console.log()
        this.zo_id = id
        let area_id = this.$route.query.area_id
        let district_and_name = this.$route.query.district_and_name
        this.district_and_name = district_and_name
        let district_and_county = this.$route.query.district_and_county
        this.getTextpaperInfo(id)
        this.recommendList(area_id, district_and_name, district_and_county)
        this.reviewList(id)
        document.documentElement.scrollTop = 0;
    },
    components: {
      login,Bottom,proposal,kfu
    },
  };
</script>

<style lang="less" scoped>

.detail_body > div {
    position: relative;
    z-index: 1;
}
.detail_body_list > .spaniv {
    position: relative;
    z-index: 1;
}
.detail_body a {
    position: relative;
    z-index: 1;
}
.content_help > div {
    position: relative;
    z-index: 1;
}
.detail_body_list > .detail_body_list-spa {
    position: fixed;
    width: 100%;
    height: 20%;
    z-index: 1;
    top: -15vh;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background: url('../../assets/img/logo_si.png') 45% 45%;
    background-size: 8rem 2.5rem;
    background-repeat: no-repeat;
    transform: rotate(-20deg);
}

.flied {
    position: fixed;
    right: .3rem;
    bottom: 2rem;
    > div {
        width: 0.93rem;
        height: 0.93rem;
        background: rgba(255,255,255,0.9);
        box-shadow: 0rem 0rem 10px rgba(71, 76, 100, 0.19);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .3rem;
        > img {
            height: .43rem;
        }
    }
}

h1,h2,h3,h4,h5,h6 {
    margin: 0;
}

.deatil_title {
    padding: .31rem;
    margin-right: 0.5rem;
    text-align: justify;
    text-align-last: justify;
    text-justify: distribute-all-lines;
    font-size: 0.26rem;
    font-weight: 500;
    color: #808080;
    flex-shrink: 0;
    min-width: 1.06rem;
}

.detail_body {
    /deep/ .van-tabs__nav--line {
        width: 3rem;
    }
    .detail_body_span {
        width: 7.5rem;
        display: block;
        height: 0.19rem;
        background: #F4F4F5;
    }
    .detail_body_banner {
        width:7.5rem;height: 5.61rem;background: #000000;margin: 0 auto;overflow: hidden;
        img {
            height:100%;
        }
    }

    .detail_body_title {
        padding: .31rem;
        > h3 {
            margin-top: .3rem;
            font-size: 0.36rem;
            font-weight: bold;
            color: #000007;
            line-height: 0.44rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            font-family: PingFang SC;
            overflow: hidden;
            color: #000007;
        }

        > .detail_body_title_flex {
            display: flex;
            justify-content: space-between;
            .detail_body_title_flex_left {
                font-size: 0.28rem;
                font-weight: 800;
                color: #FF3B00;
                font-family: PingFang SC;
                span {
                    font-size: 0.58rem;
                }
            }

            .detail_body_title_flex_right {
                font-size: 0.24rem;
                font-weight: 500;
                display: flex;
                align-items: flex-end;
                color: #7D7D84;
            }
        }
    }

    .spaniv {
        width: 7.5rem;
        margin: 0 auto;
        display: flex;
        > div {
            margin-right: .2rem;
            font-size: .32rem;margin-left: .28rem;color: #6D6E70;line-height: .8rem;
        }
        .spaniv_active {
            color: #040404;
            border-bottom: .04rem solid #FA7368;
        }
    }
    .body_p {
        > .body_p_sp {
            margin-top: .6rem;
            font-size: 0.3rem;
            font-weight: 500;
            color: #6E6E6E;
            position: relative;
            text-align: center;
            &::after {
                content: '';
                width: 0.95rem;
                height: 0.01rem;
                background: linear-gradient(to right, #C8C8C8 , #FFF);;
                position: absolute;
                top: 0;
                bottom: 0;
                right: .6rem;
                margin: auto;
            }

             &::before {
                content: '';
                width: 0.95rem;
                height: 0.01rem;
                background:  linear-gradient(to left, #C8C8C8 , #FFF);;;
                position: absolute;
                top: 0;
                bottom: 0;
                left: .6rem;
                margin: auto;
            }
        }
        > .body_p_img {
            margin: 0 auto;
            margin-top: .38rem;
            display: block;
            height: 1.58rem;
        }
    }

    .detail_body_list_class {
        padding: .3rem;
        .detail_body_list_classtitle {
            display: flex;
            align-items: center;
            img {
                height: .4rem;
            }

            > p {
                font-size: 0.32rem;
                font-family: PingFang SC;
                font-weight: bold;
                color: #343434;
                margin-left: .17rem;
                > span {
                    color: #FF774E;
                }
            }
        }

        .detail_body_list_class_item {
            width: 6.9rem;
            padding: .19rem;
            background: #FFFFFF;
            box-shadow: 0rem 0rem 10px rgba(0, 0, 0, 0.06);
            border-radius: 0.15rem;
            margin-top: .34rem;
            display: flex;
            > .detail_body_list_class_item_left {
                width: 2.52rem;
                height: 1.89rem;
                border-radius: 0.07rem;
                overflow: hidden;
                > img {
                    height: 100%;
                }
            }

            > .detail_body_list_class_item_right {
               
                margin-left: .31rem;
                > h3 {
                     width: 3.59rem;
                     height: .7rem;
                    font-size: 0.26rem;
                    font-family: PingFang SC;
                    color: #1C2027;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                > p {
                    width: 3.6rem;
                    font-size: 0.22rem;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #8D8D8D;
                    overflow:hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow:ellipsis;
                }

                >div {
                    display: flex;
                    justify-content: space-between;
                    margin-top: .4rem;
                    > span {
                        font-size: 0.32rem;
                        font-family: PingFang SC;
                        color: #F96B60;
                        > span {
                            font-size: .22rem;
                        }
                    }

                    > a {
                        width: 1.38rem;
                        height: 0.4rem;
                        line-height: .4rem;
                        background: linear-gradient(90deg, #FA7368, #EC5448);
                        border-radius: 0.2rem;
                        font-size: 0.24rem;
                        text-align: center;
                        font-family: PingFang SC;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
}

.clas_parpoosal {
    margin-bottom: 30px;
}

.detail_body > .body_p {
    margin: 0 auto;
    /* padding-bottom: 2rem; */
    word-break: break-all;
    word-wrap: break-word;
    padding: 0.31rem;
    ol,
    div {
        width: 100% !important;
    }
    p {
        width: 100% !important;
    }
}

.detail {
    padding-bottom: 1.3rem;
}

.detail_fle {
    width: 7.5rem;
    height: 1.32rem;
    background: #FFFFFF;
    box-shadow: 0rem 0rem 10px rgba(7, 0, 2, 0.06);
    position: fixed;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        width: 6.04rem;
        height: 0.76rem;
        background: linear-gradient(90deg, #FD9366, #FF734A);
        border-radius: 0.38rem;
        font-size: 0.3rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 0.76rem;
        border: none;
    }
}

.detail_fle_flex {
    display: flex;
    width: 6.8rem;
    justify-content:space-between;
    > button {
        width: 1rem;
        height: 1rem;
        background: #FF774E;
        font-weight: 400;
        border-radius: 50%;
        font-size: 0.2em;
        color: #FFFFFF;
    }
}

.van-cell {
    width: 5.62rem;
    height: 0.75rem;
    background: #F4F4F4;
    border-radius: 0.38rem;
    display: flex;
    align-items: center;
    > div {
        display: flex;
        align-items: center;
    }
}

.box_body_s {
    padding: .3rem;
    border-top: 1px solid #EEEEEE;
    padding-bottom: 1rem;
}

.detail,.box_body {
	background-color: #FFF;

}
.box_body>.box_list {
    position: relative;
    z-index: 0;
}
.box_body>.box_list>h4 {
    font-size: .36rem;
    font-weight: 500;
    color: #333333;
}

.box_body>.box_list>span {
    width: 1.44rem;
    height: .18rem;
    display: block;
    background: rgba(255, 112, 115, .16);
    position: absolute;
    bottom: .01rem;
    z-index: 0;
}

.box_ul {
    .box_ul_item {
        display: flex;
        margin-top: .4rem;
        
        .box_ul_left {
            display: flex;
            img {
                 width: 0.7rem;
                height: 0.7rem;
                border-radius: 50%;
            }
        }

        .box_ul_right {
            width: 90%;
            margin-left: .18rem;
            padding-bottom: .4rem;
            border-bottom: 1px solid #F1F1F1;
            .box_ul_right_title {
                widows: 100%;
                display: flex;
                justify-content: space-between;
                div {
                    display: flex;
                    align-items: center;
                    > p {
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #767980;
                    }
                    &:nth-child(1) {
                        > span {
                            padding: 0 .2rem;
                            height: 0.35rem;
                            margin-left: .2rem;
                            background: #F1F1F1;
                            border-radius: 0.03rem;
                            font-size: 0.22rem;
                            font-weight: 500;
                            color: #ABAAAA;
                            line-height: 0.35rem;
                        }
                    }
                    &:nth-child(2) {
                        display: flex;
                        align-items: center;
                        > span {
                            display: block;
                            font-size: 0.24rem;
                            font-weight: 500;
                            color: #555555;
                            margin-top: .05rem;
                        }
                        > img {
                            height: .32rem;
                            margin-left: .2rem;
                        }
                    }
                }
            }

            > p {
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #B3B3B3;
                margin-top: .03rem;
            }

            > .box_ul_p {
                width: 5.87rem;
                font-size: 0.34rem;
                font-weight: 500;
                color: #303030;
                margin-top: .2rem;
                line-height: 0.5rem;
            }

            .box_ul_ps {
                width: 5.87rem;
                padding: .26rem;
                background: #F5F5F7;
                margin-top: .2rem;
                border-radius: 0.1rem;
                font-size: 0.3rem;
                font-weight: 500;
                color: #545664;
                line-height: 0.5rem;
                > span {
                    color: #2F9AE7;
                }
            }
        }
    }
}

.Results_body_a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    text-align: center;
    color: #FF774E;
    margin-top: 0.3rem;
    margin-bottom: .3rem;
    > i {
        margin-top: 0.05rem;
        margin-left: 0.05rem;
    }
}
.van-cell {
    height: 1rem;
    padding-left: .2rem;
    font-size: .3rem;
}
</style>
